/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { push } from "connected-react-router";
import { isIOS } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { bool } from "prop-types";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomData from "pages/_components/CustomData/CustomData";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import Action from "pages/_components/Action";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import VepsInProgress from "./vepsInProgress/VepsInProgress";
import VepsHistoric from "./vepsHistoric/VepsHistoric";
import Taxpayers from "./taxpayers/Taxpayers";
import AddTaxpayerForm from "./components/AddTaxpayerForm";

const vepPaymentsTabTitles = ["vep.payments.inProgress", "vep.payments.historic", "vep.taxpayers"];

const VEPPaymentsPage = ({ isDesktop, fetchingAfipAccess }) => {
    const dispatch = useDispatch();
    const { state = { tab: 0 } } = useLocation();
    const [tabIndex, setTabIndex] = useState(state.tab);
    const [openSideForm, setOpenSideForm] = useState(false);
    const [disableAFIPServices, setDisableAFIPServices] = useState(false);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.cleanVepsList());
        const disable = configUtils.getBoolean("vep.payment.disable.options", false);
        setDisableAFIPServices(disable);
    }, []);

    const tabsData = [
        {
            text: vepPaymentsTabTitles[0],
            textType: "I18N",
        },
        {
            text: vepPaymentsTabTitles[1],
            textType: "I18N",
        },
        {
            text: vepPaymentsTabTitles[2],
            textType: "I18N",
        },
    ];

    const handleAddTaxpayer = () => {
        setOpenSideForm(true);
    };

    const onClose = () => {
        setOpenSideForm(false);
    };

    const options = [
        {
            text: "vep.new.taxpayer.button",
            textType: "I18N",
            func: () => handleAddTaxpayer(),
        },
    ];

    const handleGoToAfipServices = () => {
        dispatch(push("/arcaPaymentSchedule"));
    };

    return (
        <>
            <Notification scopeToShow="vepPayments" />
            <ResponsiveHeader id="menu.payments.vepPayment">
                {!disableAFIPServices && (
                    <DesktopButtons moreOptions={options}>
                        <Button
                            className="btn btn-outline btn-block small"
                            onClick={() => dispatch(afipPaymentLinkActions.accessAfipPortal())}
                            loading={fetchingAfipAccess}>
                            <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                            <I18n id="vep.payments.afip.button" />
                        </Button>
                        <Button className="btn btn-primary btn-block small" onClick={() => handleGoToAfipServices()}>
                            <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                            <I18n id="afip.services" />
                        </Button>
                    </DesktopButtons>
                )}
                {disableAFIPServices && (
                    <DesktopButtons moreOptions={options} secondButtonDisabled>
                        <Button
                            className="btn btn-outline btn-block small"
                            onClick={() => dispatch(afipPaymentLinkActions.accessAfipPortal())}
                            loading={fetchingAfipAccess}>
                            <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                            <I18n id="vep.payments.afip.button" />
                        </Button>
                    </DesktopButtons>
                )}
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="vep.payments.afip.button" handleClick={() => dispatch(afipPaymentLinkActions.accessAfipPortal())}/>
                    {!disableAFIPServices && (
                        <Action labelKey="afip.services" handleClick={() => handleGoToAfipServices()} />
                    )}
                    <Action labelKey="vep.new.taxpayer.button" handleClick={() => handleAddTaxpayer()} />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer className="vep">
                <div className="container--alert" role="alert">
                    <div className="alert alert-info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText={i18nUtils.get("vep.payment.info")}
                            keepSpaceIfNoValue={false}
                        />
                    </div>
                    <div className="pb-6" />
                </div>
                <CustomTabs tabsData={tabsData} setCurrentTab={setTabIndex}>
                    <VepsInProgress isDesktop={isDesktop} />
                    <VepsHistoric isDesktop={isDesktop} disableOptions={disableAFIPServices} />
                    <Taxpayers isDesktop={isDesktop} />
                </CustomTabs>
                <Drawer
                    openSidebar={openSideForm}
                    onClose={onClose}
                    isFullHeight={!isDesktop}
                    enableCloseButton={!!isDesktop}>
                    <AddTaxpayerForm isDesktop={isDesktop} handleClose={onClose} openForm={openSideForm} />
                </Drawer>
            </MainContainer>
        </>
    );
};

VEPPaymentsPage.propTypes = {
    isDesktop: bool.isRequired,
    fetchingAfipAccess: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetchingAfipAccess: afipPaymentLinkSelectors.getFetchingAfipAccess(state),
});
export default connect(mapStateToProps)(VEPPaymentsPage);
